<template>
  <v-container>
    <v-row class="mb-3" no-gutters justify="space-between" align="center">
    <h2 class="text-h2">Newsletter templates</h2>
    <div>
    <span class="mr-1"><!-- The span is required because the class on action button is applied to the tooltip and not to the button -->
    <action-button @click="jsonDialog=true" icon="$json" tooltip="Create template from Unlayer JSON" color="secondary" fab small dark />
    </span>
    <action-button @click="createTemplate" icon="$add" tooltip="Create empty template" color="primary" fab small dark :loading="creating" />
    </div>
    </v-row>
    <v-data-table v-if="list" :headers="headers" :items="list" :loading="listLoading" show-expand>
      <template v-slot:item.name="i">
        <router-link :to="{ name: 'newsletter-template', params: { nstemplate: i.item.id } }">{{ i.item.name }}</router-link>
      </template>
      <template v-slot:item.public="i">
        <tooltip-icon v-if="i.item.public" icon="$ok" tooltip="Public" color="success" />
        <tooltip-icon v-else icon="$nok" tooltip="Hidden" color="warning" />
      </template>
      <template v-slot:expanded-item="i">
         <td :colspan="i.headers.length">
        <v-container>
          <v-img width="500" v-if="i.item.preview" :src="i.item.preview" />
          <span v-else>No preview available</span>
        </v-container>
         </td>
      </template>
      <template v-slot:item.actions="i">
        <action-button icon="$edit" tooltip="Edit template" :to="{ name: 'newsletter-template', params: { nstemplate: i.item.id } }" />
        <action-button icon="$copy" tooltip="Duplicate template" @click="duplicateTemplate(i.item.id)" />
        <action-button icon="$remove" tooltip="Delete template" @click="toDelete= i.item.id; confirmDelete = true;" />
      </template>
    </v-data-table>
    <v-skeleton-loader v-else
      type="table"
    ></v-skeleton-loader>
    <confirm-dialog v-model="confirmDelete" @confirm="deleteTemplate(toDelete)">Are you sure you want to delete the template?</confirm-dialog>
    <v-btn color="primary" v-if="nextToken != null" @click="loadList">Load more</v-btn>
    <v-dialog v-model="jsonDialog">
      <v-card>
        <v-card-title>Import Unlayer JSON</v-card-title>
        <v-card-text>
          <v-textarea placeholder="Paste JSON here" rows="20" v-model="json" />
        </v-card-text>
        <v-card-actions>
          <v-btn text color="primary" @click="createTemplate" :loading="creating"><v-icon left>$add</v-icon>Create</v-btn>
          <v-btn text @click="jsonDialog=false"><v-icon left>$close</v-icon>Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-container>
</template>

<script>

  import { mapState } from "vuex";

  export default {
    name: 'NewsletterTemplateList',
    data() {
      return {
        toDelete: null,
        confirmDelete: false,
        listLoading: false,
        creating: false,
        jsonDialog: false,
        json: null,
        headers: [
          { text: 'Name', value: 'name' },
          { text: 'Public', value: 'public' },
          { text: 'Preview', value: 'data-table-expand' },
          { text: 'Actions', value: 'actions' },
          
        ]
      };
    },
    computed: {
      ...mapState('nstemplates', ['list', 'nextToken', 'listDirty', 'publicOnly']),
    },
    methods: {
      getPreviewImage(key) {
        return this.$store.getters['nstemplates/getPreviewImage'](key);
      },
      loadList() {
          this.$store.dispatch('nstemplates/list', { nextToken: this.nextToken });
      },
      deleteTemplate(id) {
        this.listLoading = true;
        this.$store.dispatch('nstemplates/remove', { id }).then(() => { this.listLoading = false; this.confirmDelete = false; });
      },
      createTemplate() {
        this.creating = true;
        this.$store.dispatch('nstemplates/create', { name: 'New template', unlayerData: this.json }).then((r) => { this.creating = false; this.$router.push({name: 'newsletter-template', params: { nstemplate: r.id }}) });
      },
      duplicateTemplate(id) {
        this.creating = true;
        this.$store.dispatch('nstemplates/duplicate', { id, localizedTitle: this.$t('common.copy.title') }).then((r) => { this.creating = false; this.$router.push({name: 'newsletter-template', params: { nstemplate: r.id }}) });
      },
    },
    mounted() {
      if(!this.list || this.listDirty || this.publicOnly) {
      this.loadList();
      }
    }
  }
</script>
